import { ActivatedRoute, Router, RouteConfigLoadEnd } from '@angular/router';
import { useLoader } from 'app/utils/loader/decorators';
import { I360Validators } from 'app/utils/validator/validators';
import { EMPTY, catchError, first, switchMap, take, lastValueFrom } from 'rxjs';
import { I360FormBuilder } from 'app/utils/validator/form-builder';
import { Component, ViewChild } from '@angular/core';
import { LoaderDirective } from 'app/utils/loader/loader.directive';
import { TranslateService } from 'app/utils/translate/translate.service';
import { AuthState } from 'app/services/auth-state';
import { AuthService } from 'app/services/auth';
import { LoginService } from 'app/services/login';
import { Package } from '@imunify360-api/license';
import { AppState } from 'app/core/app.service';


enum LoginError {
    credentials = 1, service,
}

@Component({
    selector: 'i360-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
})
export class LoginComponent {
    is360Package = IMUNIFY_PACKAGE === Package.imunify360;
    LoginError = LoginError;
    form = this.formBuilder.group({
        username: this.formBuilder.control('', [I360Validators.required('username')]),
        password: this.formBuilder.control('', [I360Validators.required('password')]),
    });
    error: LoginError | null;
    @ViewChild(LoaderDirective, {static: true}) loader: LoaderDirective;

    constructor(private formBuilder: I360FormBuilder,
                private router: Router,
                private route: ActivatedRoute,
                public appState: AppState,
                private authState: AuthState,
                private authService: AuthService,
                private loginService: LoginService,
                public translate: TranslateService) {}

    @useLoader
    async login() {
        await lastValueFrom(this.loginService.login(this.form.value).pipe(
            catchError((error, caught) => {
                // eh
                if (error && Array.isArray(error.messages)) {
                    this.error = LoginError.credentials;
                } else {
                    this.error = LoginError.service;
                }

                this.form.valueChanges.pipe(take(1)).subscribe(() => {
                    this.error = null;
                });

                return EMPTY;
            }),
            take(1),
            switchMap(res => {
                this.authService.setToken(res.data.items);
                return this.route.queryParams.pipe(take(1));
            }),
            switchMap(({targetUrl}) => {
                if (!(new RegExp(`^\/${IMUNIFY_PACKAGE}\/${IMUNIFY_PACKAGE === Package.imunify360
                    ? this.authState.role.value : ''}.*`).test(targetUrl))) {
                    targetUrl =  '/';
                }

                this.router.navigateByUrl(targetUrl, { replaceUrl: true });
                return this.router.events.pipe(
                    first(event => event instanceof RouteConfigLoadEnd),
                );
            }),
        ), { defaultValue: undefined });
    }
}
